<div class="close-container close-icon" (click)="onNoClick()">
    <i class="material-icons ">close</i>
</div>

<h1 mat-dialog-title class="title-dialog"> {{"PAGES.PRODUCTS.EDIT" | translate}} {{fieldName}} </h1>
<div mat-dialog-content class="container">
    <label class="sub-title-dialog"> {{ getSubtitleText() }} </label>
    <form class="edit-form" [formGroup]="editFormGroup">
        <mat-form-field class="full-width">
            <textarea (keyup)="fieldName === 'engravement' ? onKeyUp($event) : null"
                (keydown)="fieldName === 'engravement' ? onKeyDown($event) : null"
                [style.min-height.em]="fieldName === 'activity' ? '4' : '1.5'" matInput [placeholder]="placeholderText"
                [formControlName]="'note'"></textarea>
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions class="buttons-container">
    <div class="content-btn primary">
        <button matRipple [disabled]="checkAvailability()" class="action-button" (click)="confirmClick()">
            {{"BUTTON.EDIT" |
            translate}} </button>
    </div>
</div>